module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-miner w100"
  }, [(_vm.disclaimer) ? _c('div', {
    staticClass: "result-payment-warning notification is-warning has-text-left"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.disclaimer)
    }
  })]) : _vm._e(), (!_vm.isLoading && _vm.list.length === 0) ? _c('div', {
    staticClass: "result-no-payments pos-r padding-no-results has-text-left"
  }, [_c('span', [_vm._v("You have no payouts, yet.")])]) : _vm._e(), _c('table', {
    staticClass: "table is-fullwidth table-payments"
  }, [_c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', {
      class: {
        'animate-long': item.statusChanged
      },
      attrs: {
        "id": 'payment_' + item.id
      }
    }, [_c('td', [(item.status === 'pending') ? [_vm._m(0, true)] : _vm._e(), (item.status === 'processing') ? [_vm._m(1, true)] : _vm._e(), (item.status === 'error') ? [(item.reason === 'INVALID_ADDRESS') ? [_vm._m(2, true)] : [_c('div', {
      staticClass: "errored-status"
    }, [_vm._v("We couldn't process your payment, please try again!")])]] : _vm._e(), (item.status === 'success') ? [_c('div', {
      staticClass: "completed-status"
    }, [_vm._v("Payment completed")])] : _vm._e(), _c('span', {
      staticClass: "w100 s12"
    }, [_vm._v(_vm._s(_vm._f("formatDateSecond")(item.timestamp)) + " ")]), (_vm.isMultiChain) ? _c('span', {
      staticClass: "w100 s12"
    }, [_c('span', [_vm._v("~ Via the ")]), _c('b', {
      staticClass: "w400"
    }, [_vm._v(_vm._s(item.network) + " ")]), _c('span', [_vm._v("chain")])]) : _vm._e(), (item.tx && item.tx.indexOf('Internal') > -1) ? _c('span', {
      staticClass: "w100 s12"
    }, [_c('span', [_vm._v("~ ")]), _c('span', [_vm._v(_vm._s(item.tx) + " "), _c('span', {
      staticClass: "hint--top-right hint--medium",
      attrs: {
        "aria-label": 'Payment sent directly through ' + item.exchange + '.'
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle"
    })])])]) : _vm._e()], 2), _c('td', {
      staticClass: "amount"
    }, [(item.tx) ? [(item.tx.indexOf('Internal') === -1) ? [_c('a', {
      class: {
        'error-style': item.status === 'error'
      },
      attrs: {
        "href": item.explorer_link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.amount))])] : [_c('span', {
      class: {
        'error-style': item.status === 'error'
      }
    }, [_vm._v(_vm._s(item.amount))])]] : [_c('span', {
      class: {
        'error-style': item.status === 'error'
      }
    }, [_vm._v(_vm._s(item.amount))])]], 2)])
  }), 0)]), _c('div', {
    staticClass: "bottom-controls-payments"
  }, [(_vm.hasPrev) ? _c('div', {
    staticClass: "page-switch first hint--bottom-right",
    attrs: {
      "aria-label": "First page"
    },
    on: {
      "click": _vm.first
    }
  }, [_vm._m(3)]) : _vm._e(), (_vm.hasPrev) ? _c('div', {
    staticClass: "page-switch prev hint--bottom-right",
    attrs: {
      "aria-label": "Previous page"
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._m(4)]) : _vm._e(), (_vm.hasNext) ? _c('div', {
    staticClass: "page-switch next hint--bottom-left",
    attrs: {
      "aria-label": "Next page"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._m(5)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending-status"
  }, [_c('span', [_vm._v("Payment in progress ")]), _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "processing-status"
  }, [_c('span', [_vm._v("Processing payment...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errored-status color-error"
  }, [_c('span', [_vm._v("Please check your worker(s), your address seems to be invalid! ")]), _c('span', {
    staticClass: "hint--top-right hint--medium",
    attrs: {
      "aria-label": "Check your app or worker(s) for capitalization errors, then restart the mining process and retry the payment!"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00ee9c26","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_payments.vue
// module id = 352
// module chunks = 1